import AvatarFullBodyImage from '@assets/images/learn/avatar_full_body.png'
import {Box, Flex, Image, Text, useMediaQuery} from '@chakra-ui/react'
import {PATH} from '@utils/Const'
import {useEffect} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'

const RestScreen = ({
  vocabularyData,
  setCurrentIndexQuestion,
  setCurrentIndexVocabulary,
  currentIndexVocabulary,
}: {
  vocabularyData: any
  setCurrentIndexQuestion: any
  setCurrentIndexVocabulary: any
  currentIndexVocabulary: any
}) => {
  const navigate = useNavigate()
  const [isLargerThan1280] = useMediaQuery('(min-width: 1600px)')
  const location = useLocation()
  const {setName, setId, entry_point, task_id} = location.state || {}

  useEffect(() => {
    setTimeout(() => {
      if (currentIndexVocabulary === vocabularyData?.length - 1) {
        navigate(PATH.LEARN_VOCABULARY_RESULT, {
          state: {setName, setId, entry_point, task_id},
        })
      } else {
        setCurrentIndexQuestion(0)
        setCurrentIndexVocabulary((pre: any) => pre + 1)
      }
    }, 3000)
  }, [])

  return (
    <Flex justifyContent={'center'} h={'100%'}>
      <Flex>
        <Image
          src={AvatarFullBodyImage}
          mb={'-24px'}
          w={{base: '100px', md: 'unset'}}
          objectFit={'contain'}
        />
      </Flex>
      <Flex flexDirection={'column'}>
        <Box mt={isLargerThan1280 ? '150px' : '100px'}>
          <Text fontSize={{base: '14px', md: '16px'}} fontWeight={600}>
            Perfect! Bạn đã học xong cụm {currentIndexVocabulary + 1}
          </Text>
          <Text
            fontSize={{base: '16px', md: '24px'}}
            fontWeight={600}
            maxW={'280px'}>
            Giờ mình chuyển sang học{' '}
            <Text as={'span'} color={'#FA8C16'}>
              cụm thứ {currentIndexVocabulary + 2}
            </Text>{' '}
            nha!
          </Text>
        </Box>
      </Flex>
    </Flex>
  )
}

export default RestScreen
